import { render, staticRenderFns } from "./JobTable.vue?vue&type=template&id=afc062d4&scoped=true"
import script from "./JobTable.vue?vue&type=script&lang=js"
export * from "./JobTable.vue?vue&type=script&lang=js"
import style0 from "./JobTable.vue?vue&type=style&index=0&id=afc062d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc062d4",
  null
  
)

export default component.exports